export default __webpack_public_path__ + "static/media/241104_Shop_Bilder_.5a659133.png";